import EmptyState from '@adsk/bim360-matrix-react-empty-state';
import notFoundSvg from '@adsk/bim360-matrix-react-assets/not-found.svg';
import i18n from '../../utils/i18n';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';
import coneSvg from '@adsk/bim360-matrix-react-assets/cone.svg';
import React from 'react';
import IssueFetchError from '../lib/IssueFetchError';

export const EmptyStateNotFound = () => (
  <EmptyState
    icon={{
      children: notFoundSvg,
      height: '160px',
      width: '380px'
    }}
    text={i18n.t('projectGrid.emptyState.notFound', {issueType: TYPE_QUALITY_ISSUES})}
  />
);

EmptyStateNotFound.displayName = 'EmptyStateNotFound';

export const EmptyStateDataDidntLoad = () => (
  <React.Fragment>
    <IssueFetchError />
    <EmptyState
      icon={{
        children: coneSvg,
        height: '120px',
        width: '120px'
      }}
      text={i18n.t('projectGrid.emptyState.didntLoad', {issueType: TYPE_QUALITY_ISSUES})}
    />
  </React.Fragment>
);

EmptyStateDataDidntLoad.displayName = 'EmptyStateDataDidntLoad';

export const EmptyStateSublocationsError = () => (
  <EmptyState
    icon={{
      children: notFoundSvg,
      height: '160px',
      width: '380px'
    }}
    text={i18n.t('projectGrid.emptyState.sublocations')}
    footer={i18n.t('projectGrid.emptyState.sublocationsFooter')}
  />
);

EmptyStateSublocationsError.displayName = 'EmptyStateSublocationsError';
